import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../hooks/useTranslation';

// English testimonials
const testimonialsEn = [
  {
    id: 1,
    name: 'Marie L.',
    text: 'An absolutely wonderful experience! The team is professional and speaks French perfectly. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Thomas B.',
    text: 'Simple and reliable booking. We did the safari and it was incredible. The kids loved it!',
    rating: 5,
  },
  {
    id: 3,
    name: 'Sophie M.',
    text: 'Finally a serious French-speaking contact in Hurghada. Everything was as planned, no bad surprises.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Laurent D.',
    text: 'Orange Bay is a must! Crystal clear water, well organized. We want to come back.',
    rating: 5,
  },
  {
    id: 5,
    name: 'Camille R.',
    text: 'Perfect organization for our trip to Luxor. The guide was passionate and knowledgeable. A great day!',
    rating: 5,
  },
  {
    id: 6,
    name: 'Antoine P.',
    text: 'Great responsiveness on WhatsApp. Quick answers to all my questions before the trip. Very reassuring service.',
    rating: 5,
  },
];

const TestimonialsSection = () => {
  const { language, isEnglish } = useLanguage();
  const { t } = useTranslation();
  const currentTestimonials = isEnglish ? testimonialsEn : testimonials;

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-amber-50 text-amber-600 rounded-full text-sm font-medium mb-4">
            {t('testimonials.badge')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            {t('testimonials.title')}
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentTestimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-lg hover:border-teal-200 transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Quote Icon */}
              <div className="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center mb-4 group-hover:bg-teal-100 transition-colors">
                <Quote className="w-5 h-5 text-teal-500" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 text-amber-400"
                    fill="currentColor"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-slate-600 mb-4 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Name */}
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal-400 to-cyan-400 flex items-center justify-center text-white font-semibold">
                  {testimonial.name.charAt(0)}
                </div>
                <span className="font-semibold text-slate-800">
                  {testimonial.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
